import * as Yup from "yup";
import { transformSnakeToCamel, transformModelToJson } from "utils/transform";
import { PaginationSchema } from "model/_common";
import { AffiliateSchema, AffiliateReadSchema } from "model/_base/affiliates/affiliate.schema";
import { StatsSchema } from "model/_base/stats/stats.schema";

export const DataSchema = AffiliateReadSchema.clone().transform(transformSnakeToCamel).shape({
  stats: StatsSchema,
});

export const AffiliatesSchema = Yup.object().shape({
  data: Yup.array().of(DataSchema),
  pagination: PaginationSchema,
});

export default class AffiliatesModel {
  /**
   * Transform json to model
   * @param {object} json - JSON data to transform
   * @returns {object} Transformed model
   */
  static jsonToModel(json) {
    try {
      const model = AffiliatesSchema.cast(json, {
        abortEarly: false,
        stripUnknown: true,
      });
      return model;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Transform model to json
   * @param {object} model - Model to transform
   * @returns {object} Transformed JSON
   */
  static modelToJson(model) {
    return transformModelToJson(model);
  }
}
